export default __webpack_public_path__ + "static/media/polaroid2.0286168a.jpg";